import {
    DOWNLOAD_BULK_PAYMENT_LINK_FAILED,
    DOWNLOAD_BULK_PAYMENT_LINK_REQUEST,
    DOWNLOAD_BULK_PAYMENT_LINK_SUCCESS,
    GET_LINK_ID_FOR_PRE_FILLED_FILE_FAILED,
    GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST,
    GET_LINK_ID_FOR_PRE_FILLED_FILE_SUCCESS,
    GET_RECENT_BULK_PAYMENT_LINK_FAILED,
    GET_RECENT_BULK_PAYMENT_LINK_REQUEST,
    GET_RECENT_BULK_PAYMENT_LINK_SUCCESS,
    HIDE_BULK_PAYMENT_LOADER,
    SHOW_BULK_PAYMENT_LOADER,
    UPLOAD_BULK_PAYMENT_LINK_FAILED,
    UPLOAD_BULK_PAYMENT_LINK_REQUEST,
    UPLOAD_BULK_PAYMENT_LINK_SUCCESS,
} from './BulkPaymentLink.constants';

export const fetchLinkIdForPreFilledFileRequest = payload => ({
    type: GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST,
    payload,
});

export const fetchLinkIdForPreFilledFileSuccess = payload => ({
    type: GET_LINK_ID_FOR_PRE_FILLED_FILE_SUCCESS,
    payload,
});

export const fetchLinkIdForPreFilledFileFailed = payload => ({
    type: GET_LINK_ID_FOR_PRE_FILLED_FILE_FAILED,
    payload,
});

export const fetchRecentBulkPaymentLinkRequest = payload => ({
    type: GET_RECENT_BULK_PAYMENT_LINK_REQUEST,
    payload,
});

export const fetchRecentBulkPaymentLinkSuccess = payload => ({
    type: GET_RECENT_BULK_PAYMENT_LINK_SUCCESS,
    payload,
});

export const fetchRecentBulkPaymentLinkFailed = payload => ({
    type: GET_RECENT_BULK_PAYMENT_LINK_FAILED,
    payload,
});

export const uploadBulkPaymentLinkFileRequest = payload => ({
    type: UPLOAD_BULK_PAYMENT_LINK_REQUEST,
    payload,
});

export const uploadBulkPaymentLinkFileSuccess = payload => ({
    type: UPLOAD_BULK_PAYMENT_LINK_SUCCESS,
    payload,
});

export const uploadBulkPaymentLinkFileFailed = payload => ({
    type: UPLOAD_BULK_PAYMENT_LINK_FAILED,
    payload,
});

export const downloadBulkPaymentLinkFileRequest = payload => ({
    type: DOWNLOAD_BULK_PAYMENT_LINK_REQUEST,
    payload,
});

export const downloadBulkPaymentLinkFileSuccess = payload => ({
    type: DOWNLOAD_BULK_PAYMENT_LINK_SUCCESS,
    payload,
});

export const downloadBulkPaymentLinkFileFailed = payload => ({
    type: DOWNLOAD_BULK_PAYMENT_LINK_FAILED,
    payload,
});

export const showLoader = () => ({ type: SHOW_BULK_PAYMENT_LOADER });

export const hideLoader = () => ({ type: HIDE_BULK_PAYMENT_LOADER });
